import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "submit"]

  connect() {
    if (!this.hasContainerTarget) return

    if (window.turnstile) {
      this.#render()
    } else {
      const script = document.createElement("script")
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
      script.onload = () => this.#render()
      document.head.appendChild(script)
    }
  }

  #render() {
    this.submitTarget.disabled = true

    this.widgetId = window.turnstile.render(this.containerTarget, {
      callback: () => {
        this.submitTarget.disabled = false
      }
    })
  }

  disconnect() {
    if (this.widgetId) {
      window.turnstile.remove(this.widgetId)
    }
  }
}
